import React from 'react';
import './ProjectsHeroStyles.css';

const ProjectsHero = ({ projectCount = 4 }) => {
  return (
    <header className="projects-hero">
      <div className="projects-hero-grid" aria-hidden="true" />
      <div className="projects-hero-inner">
        <p className="projects-eyebrow">Portfolio Archive</p>
        <h1 className="projects-title">
          Selected
          <span className="projects-title-accent"> Works</span>
        </h1>
        <p className="projects-lede">
          Curated builds across AI, commerce, and full-stack development — each
          shaped for real users, not demo pages.
        </p>
        <div className="projects-meta">
          <span>{String(projectCount).padStart(2, '0')} Projects</span>
          <span className="projects-meta-dot" />
          <span>2023 — Present</span>
        </div>
      </div>
      <div className="projects-hero-rule" />
    </header>
  );
};

export default ProjectsHero;
